/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import {
  LOAD_CLOSED_BOARDS_ERROR,
  LOAD_CLOSED_BOARDS_REQUEST,
  LOAD_CLOSED_BOARDS_SUCCESS,
  LoadClosedBoardsErrorAction,
  LoadClosedBoardsRequestAction,
  LoadClosedBoardsSuccessAction,
} from 'modules/loaders';

// eslint-disable-next-line no-restricted-imports
import { createReducer } from 'util/reducers';

export interface ClosedBoardsState {
  isLoading: boolean;
  hasError: boolean;
}

const initialState: ClosedBoardsState = {
  isLoading: false,
  hasError: false,
};

export default createReducer(initialState, {
  [LOAD_CLOSED_BOARDS_REQUEST](
    state,
    { payload }: LoadClosedBoardsRequestAction,
  ) {
    return { isLoading: true, hasError: false };
  },
  [LOAD_CLOSED_BOARDS_SUCCESS](
    state,
    { payload }: LoadClosedBoardsSuccessAction,
  ) {
    return { isLoading: false, hasError: false };
  },
  [LOAD_CLOSED_BOARDS_ERROR](state, { payload }: LoadClosedBoardsErrorAction) {
    return { isLoading: false, hasError: true };
  },
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/ui/closed-boards.ts